import { Users, Trash2 } from "lucide-react";
import { ConfirmDialog } from "./ConfirmDialog";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "./ui/accordion";
import CandidateRankingTable from "./CandidateRankingTable";

export default function BatchAccordionList({ batches, onSelect, openValues, onOpenChange, onDeleteCandidate, onDeleteBatch }) {
  return (
    <Accordion type="multiple" value={openValues} onValueChange={onOpenChange} className="space-y-3" data-testid="batch-accordion-list">
      {batches.map(({ batchNumber, candidates, pending, inProgress }) => {
        const avg = candidates.length ? Math.round(candidates.reduce((s, c) => s + c.overall_score, 0) / candidates.length) : 0;
        return (
          <AccordionItem
            key={batchNumber}
            value={`batch-${batchNumber}`}
            className="overflow-hidden rounded-2xl border border-border/80 bg-card shadow-sm"
            data-testid={`batch-accordion-${batchNumber}`}
          >
            <AccordionTrigger className="px-5 py-4 hover:no-underline [&>svg]:h-4 [&>svg]:w-4">
              <div className="flex flex-1 flex-wrap items-center gap-2.5 text-left">
                <span className="font-heading font-semibold">Batch {batchNumber}</span>
                {inProgress && (
                  <span className="rounded-full bg-primary/10 px-2 py-0.5 text-xs font-medium text-primary animate-pulse">Uploading...</span>
                )}
                <span className="flex items-center gap-1 text-xs text-muted-foreground">
                  <Users className="h-3 w-3" /> {candidates.length} candidate{candidates.length === 1 ? "" : "s"}
                </span>
                {candidates.length > 0 && (
                  <span className="rounded-full bg-primary/10 px-2 py-0.5 font-mono text-xs font-semibold text-primary">Avg {avg}%</span>
                )}
              </div>
            </AccordionTrigger>
            <AccordionContent className="border-t border-border/60 px-0 pb-0 pt-0">
              <div className="p-4 sm:p-5">
                {onDeleteBatch && candidates.length > 0 && (
                  <div className="mb-3 flex justify-end">
                    <ConfirmDialog
                      testId={`delete-batch-dialog-${batchNumber}`}
                      title={`Delete Batch ${batchNumber}?`}
                      description={`This removes all ${candidates.length} candidate evaluation(s) in this batch. Other batches and the job itself are kept. Credits already spent are not refunded and this cannot be undone.`}
                      confirmLabel="Delete batch"
                      onConfirm={() => onDeleteBatch(batchNumber)}
                    >
                      <button
                        data-testid={`delete-batch-btn-${batchNumber}`}
                        className="inline-flex items-center gap-1.5 rounded-lg border border-destructive/40 px-2.5 py-1.5 text-xs font-medium text-destructive transition-colors duration-150 hover:bg-destructive/10"
                      >
                        <Trash2 className="h-3.5 w-3.5" /> Delete Batch {batchNumber}
                      </button>
                    </ConfirmDialog>
                  </div>
                )}
                <CandidateRankingTable candidates={candidates} onSelect={onSelect} pending={pending} onDelete={onDeleteCandidate} />
              </div>
            </AccordionContent>
          </AccordionItem>
        );
      })}
    </Accordion>
  );
}
